import { Divider, Grid } from '@mui/material';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { CustomTextAreaNoForm, CustomTextFieldNoForm, SampleCheckboxNoForm, SampleDatePickerNoForm, TabTextLabel } from '@/shared/components/ui';
import { gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg6 } from '@/shared';
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { useCreateAuditReview, useUpdateWorkOrder } from '../actions/noc-module.actions';
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';

export type AuditReviewModalProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    form: any;
    refetch: () => void;
};

export type BoxType = {
    name: string;
};

type SaveFormData = Omit<any, 'workOrderId'>;

const AuditReviewModal: React.FC<AuditReviewModalProps> = ({
    open,
    setOpen,
    form,
    refetch
}) => {
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    //* handlers
    const handleClose = () => {
        setOpen(false);
    };

    const formatLocalTime = (date: Date | string | null) => {
        if (!date) return null;
        const d = new Date(date);
        return d.toTimeString().split(' ')[0]; // HH:mm:ss
    };

    const newAuditSchema = yup.object({
        startTimeOrder: yup.string().required('Inicio de jornada requerido'),
        endTimeOrder: yup.string().required('Fin de jornada requerido'),
    });

    const formAudit = useForm<SaveFormData>({
        resolver: yupResolver(newAuditSchema as any),
        defaultValues: {
            startTimeOrder: '',
            endTimeOrder: '',
            lunchTime: '',
            overtime: '',
            startTimeOrder2: '',
            endTimeOrder2: '',
            lunchTime2: '',
            overtime2: '',
            detailReportAuditReview: '',
            userRegister: username,
            workOrderId: undefined,
        },
    });

    useEffect(() => {
        if (!open) return;

        const values = form.getValues();

        formAudit.reset({
            startTimeOrder: values.startTimeOrder ? `2000-01-01T${values.startTimeOrder}` : '',
            endTimeOrder: values.endTimeOrder ? `2000-01-01T${values.endTimeOrder}` : '',
            lunchTime: values.lunchTime || '',
            overtime: values.overtime || '',

            startTimeOrder2: values.startTimeOrder2 ? `2000-01-01T${values.startTimeOrder2}` : '',
            endTimeOrder2: values.endTimeOrder2 ? `2000-01-01T${values.endTimeOrder2}` : '',
            lunchTime2: values.lunchTime2 || '',
            overtime2: values.overtime2 || '',

            detailReportAuditReview: '',
            userRegister: username,
            workOrderId: values.workOrderId,
        });
    }, [open, form, formAudit.reset, username]);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = formAudit;

    const handleChange = (field: string, value: any) => {
        formAudit.setValue(field as any, value, {
            shouldDirty: true,
            shouldValidate: true,
        });
    };

    const [isLoading, setIsLoading] = useState(false);
    // hook para registrar orden de trabajo noc
    const useCreateAuditReviewMutation = useCreateAuditReview();
    const useUpdateWorkOrderMutation = useUpdateWorkOrder(form.getValues().workOrderId);

    const onSave = () => {

        if (form.getValues().activitiesOrder.length === 0) {
            toast.error("Debe agregar al menos una actividad");
            return false;
        }

        if (formAudit.getValues().startTimeOrder === '' || formAudit.getValues().endTimeOrder === '') {
            toast.error("Debe ingresar la hora inicial/final de la primera jornada laboral");
            return false;
        }
        if (formAudit.getValues().lunchTime === '' || formAudit.getValues().overtime === '') {
            toast.error("Debe ingresar el tiempo de almuerzo y horas extras de la primera jornada laboral");
            return false;
        }
        if (formAudit.getValues().detailReportAuditReview === '') {
            toast.error("Debe ingresar el detalle del informe de auditoría");
            return false;
        }

        setIsLoading(true);

        const values = formAudit.getValues();
        const payloadAudit = {
            ...values,
            startTimeOrder: formatLocalTime(values.startTimeOrder),
            endTimeOrder: formatLocalTime(values.endTimeOrder),
            startTimeOrder2: formatLocalTime(values.startTimeOrder2),
            endTimeOrder2: formatLocalTime(values.endTimeOrder2),
        };

        useCreateAuditReviewMutation.mutate(payloadAudit, {
            onSuccess: () => {
                const payload = {
                    ...form.getValues(),
                    orderStatus: "FINALIZADO",
                    userModify: username
                };

                useUpdateWorkOrderMutation.mutate(payload, {
                    onSuccess: () => {
                        // navigate(returnUrlOrdenTrabajoPage);
                        toast.success("Orden Auditada correctamente")
                        handleClose();
                        refetch();
                        setIsLoading(false);
                    },
                    onError: (error) => {
                        console.error('Error al auditar la orden de trabajo:', error);
                        toast.error('Error al auditar la orden de trabajo');
                        setIsLoading(false);
                    }
                });
            },
            onError: (error) => {
                console.error('Error al auditar la orden de trabajo:', error);
                toast.error('Error al auditar la orden de trabajo');
                setIsLoading(false);
            }
        });
    };

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Confirmación de Auditoria"}
                width="100%"
                contentNode={
                    <>
                        <Grid container spacing={3}>
                            <CustomTextFieldNoForm
                                label="Nombre de la Orden"
                                defaultValue={form.getValues().orderName || ''}
                                size={gridSizeMdLg6}
                                disabled={true}
                            />
                            <CustomTextFieldNoForm
                                label="Fecha de Trabajo"
                                defaultValue={form.getValues().workDate || ''}
                                size={gridSizeMdLg6}
                                disabled={true}
                            />
                            <Grid item {...gridSizeMdLg6}>
                                <SampleCheckboxNoForm
                                    label="Es Orden de Alcance ?"
                                    defaultValue={!!form.getValues().isScope || false}
                                    disabled={true}
                                />
                            </Grid>
                            <SampleDatePickerNoForm
                                label="Fecha de Trabajo Anterior"
                                defaultValue={form.getValues().previousWorkDate || ''}
                                size={gridSizeMdLg6}
                                disabled={true}
                            />

                        </Grid>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <TabTextLabel
                                    text={"INFORMACIÓN PRIMERA JORNADA LABORAL"}
                                    mt={0}
                                    pb={2}
                                    pl={0}
                                    pt={2}
                                />
                            </Grid>

                            <TimeClockComponente
                                label="Inicio de la jornada"
                                size={gridSizeMdLg3}
                                control={control}
                                error={errors.startTimeOrder}
                                name="startTimeOrder"
                                enableDateTypeResult={true}
                                helperText={errors.startTimeOrder?.message?.toString() ?? ''}
                            />
                            <TimeClockComponente
                                label="Fin de la jornada"
                                size={gridSizeMdLg3}
                                control={control}
                                error={errors.endTimeOrder}
                                name="endTimeOrder"
                                enableDateTypeResult={true}
                                helperText={errors.endTimeOrder?.message?.toString() ?? ''}
                            />

                            <CustomTextFieldNoForm
                                label="Tiempo Almuerzo"
                                type="number"
                                value={formAudit.getValues().lunchTime || ''}
                                size={gridSizeMdLg3}
                                onChangeCustom={(row) => {
                                    handleChange('lunchTime', row.target.value)
                                }}
                            />
                            <CustomTextFieldNoForm
                                label="Horas Extras"
                                type="number"
                                value={formAudit.getValues().overtime || ''}
                                size={gridSizeMdLg3}
                                onChangeCustom={(row) => {
                                    handleChange('overtime', row.target.value)
                                }}
                            />


                            <Grid item xs={12}>
                                <TabTextLabel
                                    text={"INFORMACIÓN SEGUNDA JORNADA LABORAL (OPCIONAL)"}
                                    mt={0}
                                    pb={2}
                                    pl={0}
                                    pt={2}
                                />
                            </Grid>

                            <TimeClockComponente
                                label="Inicio de la jornada"
                                size={gridSizeMdLg3}
                                control={control}
                                error={errors.startTimeOrder2}
                                name="startTimeOrder2"
                                enableDateTypeResult={true}
                                helperText={errors.startTimeOrder2?.message?.toString() ?? ''}
                            />
                            <TimeClockComponente
                                label="Fin de la jornada"
                                size={gridSizeMdLg3}
                                control={control}
                                error={errors.endTimeOrder2}
                                name="endTimeOrder2"
                                enableDateTypeResult={true}
                                helperText={errors.endTimeOrder2?.message?.toString() ?? ''}
                            />

                            <CustomTextFieldNoForm
                                label="Tiempo Almuerzo"
                                type="number"
                                value={formAudit.getValues().lunchTime2 || ''}
                                size={gridSizeMdLg3}
                                onChangeCustom={(row) => {
                                    handleChange('lunchTime2', row.target.value)
                                }}
                            />
                            <CustomTextFieldNoForm
                                label="Horas Extras"
                                type="number"
                                value={formAudit.getValues().overtime2 || ''}
                                size={gridSizeMdLg3}
                                onChangeCustom={(row) => {
                                    handleChange('overtime2', row.target.value)
                                }}
                            />

                        </Grid>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Divider sx={{ my: 4 }} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            <CustomTextAreaNoForm
                                label="Detalle una observación de la auditoria"
                                size={gridSizeMdLg12}
                                value={formAudit.getValues().detailReportAuditReview || ''}
                                onChangeValue={(value) => {
                                    handleChange('detailReportAuditReview', value)
                                }}
                            />
                        </Grid>

                    </>
                }
                onClose={handleClose}
                confirmDisabled={isLoading}
                onConfirm={handleSubmit(onSave)}
                confirmTextBtn={"Registrar Auditoria"}
            />
        </>
    );
};

export default AuditReviewModal;
